<template>
  <div class="profile">
    <h2>Profile</h2>

      <div class="card mb-5">
        <div class="card-body">
          <h3 class="card-title">
            <span><i class="bi bi-person-circle me-2"></i> Profile</span>
          </h3>
          <profile-info />
        </div>
      </div>


    <div class="accordion accordion-flush mb-5" id="accordionSettings">
      <accordian-item v-if="isAdmin" id="profile-debug" label="DEBUG" icon-name="bi-bug-fill">
        <profile-settings />
      </accordian-item>
    </div>

<!--    <logout-button class="btn btn-light btn-outline-primary"/>-->

  </div>
</template>

<script setup>
import AccordianItem from "@/app/components/Utils/AccordionItem.vue";
import ProfileSettings from "@/app/components/profile/ProfileSettings.vue";
// import LogoutButton from "@/app/components/LogoutButton.vue";
import ProfileInfo from "@/app/components/profile/ProfileInfo.vue";

import { useStore } from 'vuex';
import { computed } from 'vue';
const store = useStore();
const isAdmin = computed(() => store.state.user?.isAdmin)

</script>

<style lang="scss" scoped>
.profile {
  .card-body {
    padding-bottom: 2rem;
  }
  .card-title {
    margin-bottom: 1.5rem;
  }
  h2.profile-header {
    text-align: center;
    display: grid;
    grid-auto-flow: column;
    margin: 2rem 0;
    &::before, &::after {
      content: '';
      border-bottom: 2px solid #ccc;
      height: 50%;
    }
  }
}
</style>
